import Link from 'next/link';
import { useRouter } from 'next/router';

import { Anchor, Icon } from '@zillow/constellation-10';
import { IconSearchFilled } from '@zillow/constellation-icons';

import QueryConstants from '../../constants/QueryConstants';
import { ROUTES } from '../../constants/urls';

import EmptyState from '../EmptyState';

export const NoSearchResults = ({
  showArchived,
  onRemoveSearchTextClick,
}: {
  showArchived: boolean;
  onRemoveSearchTextClick: () => void;
}) => {
  const router = useRouter();

  return (
    <EmptyState
      icon={<Icon render={<IconSearchFilled />} size="md" css={{ color: 'icon.subtle' }} />}
      heading="No properties found for the following filters"
      headingLevel={3}
      body={
        !showArchived && (
          <>
            Would you like to{' '}
            <Anchor asChild>
              <Link
                href={{
                  pathname: ROUTES.PROPERTIES,
                  query: { ...router.query, [QueryConstants.POSTING_PATH]: 'true' },
                }}
              >
                post a listing
              </Link>
            </Anchor>
            ?
          </>
        )
      }
      secondaryAction={{ label: 'Remove search', onClick: onRemoveSearchTextClick }}
      align="center"
      useCard={false}
    />
  );
};
